import {createSelector} from "@reduxjs/toolkit";
import {reviewCardSelector} from "./_selectors/reviewCard.selector";
import {reviewStoreSelector} from "./_selectors/reviewStore.selector";
import {ReviewStateProps} from "./review.interface";
import {getCurrentSubcard, getSubcardProgress, hasMoreSubcards} from "./utils/multicard.utils";

export const reviewSelector = createSelector(
    [
        reviewCardSelector,
        reviewStoreSelector,
    ],
    (card, reviewStore) : ReviewStateProps => {
        // Get current subcard if this is a multicard
        const currentSubcard = getCurrentSubcard(reviewStore);
        
        // Get progress information for subcards
        const subcardProgress = reviewStore.isMultiCard ? 
            getSubcardProgress(reviewStore) : undefined;
        
        // Check if there are more subcards available
        const hasMoreSubcardsAvailable = reviewStore.isMultiCard ? 
            hasMoreSubcards(reviewStore.allSubcards.length, reviewStore.viewedSubcardIndices) : false;
        
        return {
            cardId: card?.cardId,
            markup: card?.markup,
            reviewState: reviewStore.state,
            markupState: reviewStore.markupState,
            // MultiCard specific props
            isMultiCard: reviewStore.isMultiCard,
            currentSubcard,
            subcardProgress,
            hasMoreSubcards: hasMoreSubcardsAvailable,
            currentSubcardIndex: reviewStore.currentSubcardIndex,
            current: reviewStore.cardNumberInReview,
            total: reviewStore.totalCardsForReview
        }
    }
);
